<!--
radio
用例：
<radio value="normal" v-model="userTypeSelection" text="普通"></radio>
<radio value="group" v-model="userTypeSelection" text="集团"></radio>

注意：
一般用于高级搜索中

cancelable = true时：
1）支持取消选中
2）value:[String, Number, Boolean],
  selection: [Array, String]
//-->
<template>
  <div class="radio-component" @click="_toggleItem">
    <!-- <span class="radio-icon" :class="iconClassName"></span> -->
    <i v-if="selected" class="el-icon-circle-check lc-primary-color"></i>
    <i v-else class="iconfont lc-icon-uncheck" style="font-size: 14px"></i>
    <label class="radio-text">{{ text }}</label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'selection',
    event: 'changed'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: 0
    },
    selection: [String, Number, Boolean, Object],
    text: String,
    cancelable: {
      type: Boolean,
      default: false
    },
    /**
     * @property {boolean} readonly 是否只读
     */
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {}
  },
  computed: {
    selected() {
      if (this.cancelable) {
        return this.values.includes(this.value)
      } else {
        return this.value == this.selection
      }
    },
    iconClassName() {
      let classes = []
      classes.push(this.selected ? 'lc-primary-color' : 'radio-icon-unselected')
      if (this.readonly) classes.push(this.selected ? 'radio-selected-disabled' : 'radio-unselected-disabled')
      return classes.join(' ')
    },
    values() {
      if (this.selection === null || this.selection === '' || this.selection === undefined) {
        return []
      }
      return this.cancelable ? this.selection.split(',') : this.selection
    }
  },
  methods: {
    // events
    _triggerChangedEvent(selection) {
      this.$emit('changed', selection)
    },
    _triggerClickEvent() {
      this.$emit('click')
    },
    _toggleItem() {
      // 只读
      if (this.readonly) return

      if (this.cancelable) {
        let selections = this.values.slice(0)
        if (this.selected) {
          this._removeArrayElem(selections, this.value)
        } else {
          selections = []
          selections.push(this.value)
        }
        this._triggerChangedEvent(this._selectionToValue(selections))
        this._triggerClickEvent()
      } else {
        this.$emit('click', this.value)
        this.$emit('changed', this.value)
      }
    },
    _removeArrayElem(array, elem) {
      let index = array.indexOf(elem)
      if (index >= 0) {
        array.splice(index, 1)
      }
    },
    _selectionToValue(selections) {
      if (this.cancelable) {
        if ($.isEmptyObject(selections)) {
          return null
        } else {
          return selections.join(',')
        }
      } else {
        return selections
      }
    }
  }
}
</script>

<style lang="scss">
.radio-component {
  cursor: pointer;
  justify-content: left;
  display: inline-flex;
  line-height: 20px;
  align-items: baseline;
  font-size: 14px;

  .radio-icon {
    width: 15px;
    height: 15px;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
  }
  .radio-icon-unselected {
    display: none;
    // background-image: url('/images/icons/radio_unselected.svg');
  }
  .radio-icon-selected {
    display: block;
  }

  .radio-text {
    line-height: 20px;
    margin: 0px;
    margin-left: 2px;
    cursor: pointer;
  }
}
</style>
<style lang="scss" scoped>
.radio-unselected-disabled {
  cursor: not-allowed;
}
.radio-selected-disabled {
  cursor: not-allowed;
}
</style>
